import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import AccountReducer from "./auth/register/reducer";
import BankReducer from "./Bank/reducer";
import DeveloperReducer from "./Developer/DeveloperSlice";
import LeadsReducer from "./Leads/reducer";
import LocationReducer from "./Location/LocationSlice";
import ProjectReducer from "./Project/reducer";
import RoleReducer from "./RoleManagement/reducer";

const appReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Banks: BankReducer,
  Project: ProjectReducer,
  Developer: DeveloperReducer,
  Location: LocationReducer,
  Leads: LeadsReducer,
  RoleManagement: RoleReducer,
});
const rootReducer = (state, action) => {
  if (action.type === "login/logoutUserSuccess") {
    // Clear entire redux state on logout
    state = undefined;
  }
  return appReducer(state, action);
};
export default rootReducer;
